import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3dc7e37d&scoped=true&class=full-heigth"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3dc7e37d&lang=css"
import style1 from "./index.vue?vue&type=style&index=1&id=3dc7e37d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7e37d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc7e37d')) {
      api.createRecord('3dc7e37d', component.options)
    } else {
      api.reload('3dc7e37d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3dc7e37d&scoped=true&class=full-heigth", function () {
      api.rerender('3dc7e37d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/appManage/publicAlbum/index.vue"
export default component.exports